$(function(){
  console.log("imtk_progress-lens-option.js v3");
	
  var PRODUCT_TYPE;
  try{ 
    PRODUCT_TYPE = IMTK.shopify.product.type.toLowerCase();
    //PRODUCT_TYPE = 'sun';
  }
  catch(e){
  }
  var isMobile = checkMobile(); // from imtk_common.js
  var preview =  {
    productName: undefined,
    productPrice: undefined,
    lensName: undefined,
    lensPrice: undefined,
    optionName: undefined,
    optionPrice: undefined,
    colorName: undefined,
    colorPrice: undefined,
    totalPrice: undefined,
  };
  
  
  /****************************/
  /* Settings                 */
  /****************************/
  var scrollGap = 200;
  var scrollSpeed = 600;


  /****************************/
  /* jQuerySelectors          */
  /****************************/  
  var $addToCartBtn = $("#add_to_cart");
  var $variantOptionIcons = $(".swatch-element");
  
  var $form	= $(".progress_lens_options_form");
  var $plos1 = $(".progress_lens_options_step_1");
  
  var $plos2 = $(".progress_lens_options_step_2");
  var $plos2_exit_btn = $("#progress_lens_options_step_2_exit_btn");
  var $plos2_back_btn = $("#progress_lens_options_step_2_back_btn, #progress_lens_options_step_2_back_btn2");
  var $plos2_img_container = $(".progress_lens_options_step_2_preview_img_container");
  
  var $plos2_progression_lens_option = $("#progress_lens_options_step_2_progression_lens_option");
  var $plos2_progression_prescription = $("#progress_lens_options_step_2_progression_prescription");
  
  var $plos2_prescription_type = $("#progress_lens_options_step_2_prescription_type");
  var $plos2_lens_metarial_single = $("#progress_lens_options_step_2_lens_metarial_single");
  var $plos2_lens_metarial_progress = $("#progress_lens_options_step_2_lens_metarial_progress");
  var $plos2_blue_filter = $("#progress_lens_options_step_2_blue_filter");
  var $plos2_sun_color = $("#progress_lens_options_step_2_sun_color");
  var $plos2_tinted = $("#progress_lens_options_step_2_tinted");
  var $plos2_tinted_manual = $("#tinted_manual");
  var $plos2_polarized = $("#progress_lens_options_step_2_polarized");
  var $plos2_next_btn = $("#progress_lens_options_step_2_next_btn");
  
  var $plos2_prescription_select = $("#progress_lens_options_step_2_prescription_select");
  var $plos2_prescription_upload = $("#progress_lens_options_step_2_prescription_upload");
  var $plos2_prescription_doctor = $("#progress_lens_options_step_2_prescription_doctor");
  var $plos2_pd_select = $("#progress_lens_options_step_2_pd_select");
  var $plos2_pd_upload = $("#progress_lens_options_step_2_pd_upload");
  var $plos2_pd_enter  = $("#progress_lens_options_step_2_pd_enter");
  
  var $plos2_submit_btn = $(".progress_lens_options_step_2_submit_btn");
  var check_mark_html = '<img src="'+$("#check_mark_img_url").val()+'" class="check_img">';
  
  
  /****************************/
  /* functions                */
  /****************************/
  function init(){
    updateAddToCartBtnByVariantAvailability();
    
    var $elementsForSun = $(".progress_lens_options_sun");
    var $elementsForOptical = $(".progress_lens_options_optical");
    var $elementsForUndefined = $(".progress_lens_options_undefined");
    
    switch(PRODUCT_TYPE){
      case 'sun':
        $elementsForSun.removeClass('progress_lens_options_hidden');
        break;
      case 'optical':
        $elementsForOptical.removeClass('progress_lens_options_hidden');
        break;
      default:
        $elementsForUndefined.removeClass('progress_lens_options_hidden');
        break;
    }
  }
  
  function resizeStep1(){
    $(".progress_lens_options_step_1_inner").css("width",$(".description.bottom").width()+"px");
  }
  resizeStep1();
  
  function formatMoney(num, n, x) {
 	//@param integer n: length of decimal
 	//@param integer x: length of sections
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return num.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };
  
  function matchDomHeights(domSelector){
  	var maxHeight = 0;
    $(domSelector).height("");

    if(window.innerWidth > 739){
      $(domSelector).each(function(index,element){
        maxHeight = Math.max($(element).height(), maxHeight)
      });
      if(maxHeight > 0) $(domSelector).height(maxHeight);
    }
  }

  function resetForm() {
    $('input[name="progress_lens_options_step_1_lensOptions"]:checked').prop( "checked", false );
    $(".progression_view_checked").removeClass("progression_view_checked");
    $(".plos2_prescription_type_selected").removeClass("plos2_prescription_type_selected progress_lens_options_step_2_optionButton_selected");
    $(".plos2_lens_metarial_selected").removeClass("plos2_lens_metarial_selected progress_lens_options_step_2_optionButton_selected");
    $(".plos2_blue_filter_selected").removeClass("plos2_blue_filter_selected progress_lens_options_step_2_optionButton_selected");
      
    
    $form.find("input[type='text']").val("");

    $form.find(".progress_lens_options_input_prescription").attr("disabled","disabled");
    $form.find(".progress_lens_options_input_pd").attr("disabled","disabled");
  }
  
  function setInitPreviewData(){
    var brand = IMTK.shopify.product.vendor;
    var productName = IMTK.shopify.product.title;
    var productPrice = IMTK.shopify.product.price;
    
    preview.productName =  brand+" : "+productName;
    preview.productPrice =  productPrice;
    
    var $existingImg = $plos2_img_container.find("img");
    if($existingImg) $existingImg.remove();
    // var step2_img_url=$(".product_gallery .is-selected").find("img").attr("src");
    var step2_img_url=$(".gallery .slide.slick-active").find("img").attr("data-altSrc");
    var $plos2_img = $("<img></img>");
    $plos2_img.attr("src", step2_img_url);
    console.log("Preview image url: " + step2_img_url)
    
    $plos2_img_container.append($plos2_img);
    updatePreview();
  }
  
  function updatePreview(){
    //product
    $("#preview_product_name").text(preview.productName);
    $("#preview_product_price").text(formatMoney(preview.productPrice/100));
    
    //lens
    if(preview.lensName && preview.lensPrice){
      $("#preview_lens").show();
      $("#preview_lens_name").text(preview.lensName);
      $("#preview_lens_price").text(formatMoney(preview.lensPrice/100));
    }
    else {
      $("#preview_lens").hide();
    }
    
    //option
    if(preview.optionName && preview.optionPrice){
      $("#preview_option").show();
      $("#preview_option_name").text(preview.optionName);
      $("#preview_option_price").text(formatMoney(preview.optionPrice/100));
    }
    else {
      $("#preview_option").hide();
    }
    
    //color
    if(preview.colorName && preview.colorPrice){
      $("#preview_color").show();
      $("#preview_color_name").text(preview.colorName);
      $("#preview_color_price").text(formatMoney(preview.colorPrice/100));
    }
    else {
      $("#preview_color").hide();
    }
    
    preview.totalPrice = parseInt(preview.productPrice?preview.productPrice:0) + 
      					 parseInt(preview.lensPrice?preview.lensPrice:0) + 
                         parseInt(preview.optionPrice?preview.optionPrice:0) + 
                         parseInt(preview.colorPrice?preview.colorPrice:0);
    
    $("#preview_total_price").text(formatMoney(preview.totalPrice/100));
  }

  function startStep2() {  
    $('[name="option-0"]:checked').trigger("change");//update preview img this should be done before hiding ".zoomContainer"
    $plos1.hide();
    $plos2.show();
    $(".progress_lens_options_product").addClass("progress_lens_options_hidden");
    $(".zoomContainer").hide();
    $plos2_exit_btn.show();
    $plos2_back_btn.hide();
    setInitPreviewData();
    $plos2_progression_lens_option.addClass("progression_view_checked");
    
    var selectedLensType = $(".plos2_lens_metarial_selected").data("optionType");
    switch(selectedLensType){
      case "single":
        $plos2_lens_metarial_single.show();
    	$plos2_lens_metarial_progress.hide();
        break;

      case "progressive":
    	$plos2_lens_metarial_single.hide();
        $plos2_lens_metarial_progress.show();
        break;
        
      default:
    	$plos2_lens_metarial_single.hide();
    	$plos2_lens_metarial_progress.hide();
        break;
    }
    $plos2_prescription_type.show();
    $plos2_blue_filter.show();
    $plos2_sun_color.show();
    var selectedSunColorType = $(".plos2_sun_color_selected").data("optionType");
    switch(selectedLensType){
      case "tinted":
        $plos2_tinted.show();
        $plos2_polarized.hide();
        break;

      case "polarized":
        $plos2_tinted.hide();
        $plos2_polarized.show();
        break;
        
      default:
        $plos2_tinted.hide();
        $plos2_polarized.hide();
        break;
    }
    $plos2_next_btn.show();
    $plos2_prescription_select.hide();
    $plos2_prescription_upload.hide();
    $plos2_prescription_doctor.hide();
    $plos2_pd_select.hide();
    $plos2_pd_upload.hide();
    $plos2_pd_enter.hide();
    $plos2_submit_btn.hide();
    matchDomHeights(".progress_lens_options_step_2_optionButton_description p");
    matchDomHeights(".self_test_image_boxes .p1");
    matchDomHeights(".self_test_image_boxes .p2");
    $('html, body').scrollTop($(".progress_lens_options_step_2_inside").offset().top-scrollGap);
  }

  function formSubmit(){
    var variantIds = [];
    var totalVariantPrice = 0;
    
    var $properties = $form.find(".progress_lens_options_input");
    var $variantIds = $form.find("#progress_lens_options_input_variant_ids");
    var $totalVariantPrice = $form.find("#progress_lens_options_input_total_variant_price");

    var $lensVariantId = $form.find("#progress_lens_options_input_lens_variant_id");
    var $lensVariantPrice = $form.find("#progress_lens_options_input_lens_variant_price");

    if($lensVariantId.val()){
      variantIds.push($lensVariantId.val());
      $lensVariantId.val("");
    }

    if($lensVariantPrice.val()){
      totalVariantPrice+=parseInt($lensVariantPrice.val());
      $lensVariantPrice.val("");
    }

    var $blueFilterVariantId = $form.find("#progress_lens_options_input_blue_blocking_filter_variant_id");
    var $blueFilterVariantPrice = $form.find("#progress_lens_options_input_blue_blocking_filter_variant_price");

    if($blueFilterVariantId.val()){
      variantIds.push($blueFilterVariantId.val());
      $blueFilterVariantId.val("");
    }

    if($blueFilterVariantPrice.val()){
      totalVariantPrice+=parseInt($blueFilterVariantPrice.val());
      $blueFilterVariantPrice.val("");
    }

    var $polarizedVariantId = $form.find("#progress_lens_options_input_polarized_variant_id");
    var $polarizedVariantPrice = $form.find("#progress_lens_options_input_polarized_variant_price");

    if($polarizedVariantId.val()){
      variantIds.push($polarizedVariantId.val());
      $polarizedVariantId.val("");
    }

    if($polarizedVariantPrice.val()){
      totalVariantPrice+=parseInt($polarizedVariantPrice.val());
      $polarizedVariantPrice.val("");
    }
    
    
    if(variantIds.length>0){
      $variantIds.val(variantIds.join(','));
    }

    if(totalVariantPrice>0){
      $totalVariantPrice.val(totalVariantPrice);
    }
    
//     console.log("$variantIds.val(): ", $variantIds.val());
//     console.log("$totalVariantPrice.val(): ", $totalVariantPrice.val());
    

    $properties.each(function(index,element){
      if(!$(element).val()){
      	$(element).attr("disabled","disabled");
      }
	});

    $form.submit();
  }


  /****************************/
  /* Event Listeners          */
  /****************************/
  $(window).resize(function(e) {
    resizeStep1();
    matchDomHeights(".progress_lens_options_step_2_optionButton_description p");
    matchDomHeights(".self_test_image_boxes .p1");
    matchDomHeights(".self_test_image_boxes .p2");
  });
  
  
  $variantOptionIcons.on("click",function(e){
    updateAddToCartBtnByVariantAvailability();
  });

  
  function updateAddToCartBtnByVariantAvailability(){
    setTimeout(()=>{       
      //var isAvailable = $(".swatch-element[data-id='"+new URLSearchParams(window.location.search).get('variant')+"']").hasClass("available")
      //var isAvailable = $(".swatch_options input:checked+.swatch-element").hasClass("available");
      var isAvailable = true;
               
      var $swatchOptions = $(".swatch_options [data-option-index]");
    
//       if(!$swatchOptions.length == 1){
//         isAvailable = $(".swatch_options input:checked+.swatch-element").hasClass("available");
//       }
//       else{
//         for(var i=0; i<$swatchOptions.length; i++){
//           if(!$($swatchOptions[i]).find("input:checked+.swatch-element").hasClass("available")) isAvailable = false;
//         }
//       }
    
    
      for(var i=0; i<$swatchOptions.length; i++){
        if(!$($swatchOptions[i]).find("input:checked+.swatch-element").hasClass("available")) isAvailable = false;
      }
      console.log("isAvailable: ", isAvailable);

      var defaultValue = $addToCartBtn.data("defaultValue");
      if(!defaultValue){
        defaultValue = $addToCartBtn.val();
        $addToCartBtn.data("defaultValue", defaultValue);
      }

      if(isAvailable){
        console.log("remove");
        $addToCartBtn.removeAttr("disabled");
        $addToCartBtn.attr("value", defaultValue);
      }
      else{
        console.log("add");
        $addToCartBtn.attr("disabled","disabled");
        $addToCartBtn.attr("value", "SOLD OUT");
      }
  	});
  }
  
  /* Step 1 */
  $addToCartBtn.on("click",function(e){
    //resetForm();
    
    $plos1.fadeIn(500);
    $addToCartBtn.blur();
  });

  $plos1.find(".progress_lens_options_step_1_next").on("click",function(){
    var $checked = $('input[name="progress_lens_options_step_1_lensOptions"]:checked');

    if($checked.length >0){
      $checked.removeAttr("checked");
      if($checked.data("nextAction") == "Cart"){
        formSubmit();
      } else {
      	$("html").animate({ scrollTop: 0 }, scrollSpeed);  
        startStep2();
      }
    } else {
      alert("Please select lense option to process");
    }
  });

  $plos1.find(".progress_lens_options_step_1_cancel").on("click",function(e){
    $plos1.hide();
  });

  /* Step 2 */
  $plos2_exit_btn.on("click",function(e){
    //resetForm();
    $plos2.hide();
    $(".zoomContainer").show();
    $(".progress_lens_options_product").removeClass("progress_lens_options_hidden");
    setTimeout(function(){
      $(".flickity-enabled").flickity('resize');
      resizeStep1();
    },0);
  });

  $plos2_back_btn.on("click",function(e){
    $plos2_exit_btn.show();
    $plos2_back_btn.hide();
    $plos2_progression_lens_option.addClass("progression_view_checked");
    $plos2_progression_prescription.removeClass("progression_view_checked");
    
    $plos2_prescription_type.show();
    
    var selectedLensType = $(".plos2_lens_metarial_selected").data("optionType");
    switch(selectedLensType){
      case "single":
        $plos2_lens_metarial_single.show();
        break;

      case "progressive":
        $plos2_lens_metarial_progress.show();
        break;
    }
    $plos2_blue_filter.show();
    $plos2_sun_color.show();
    var selectedSunColorType = $(".plos2_sun_color_selected").data("optionValue");
    switch(selectedSunColorType){
      case "tinted":
        $plos2_tinted.show();
        $plos2_polarized.hide();
        break;

      case "polarized":
        $plos2_tinted.hide();
        $plos2_polarized.show();
        break;
        
      default:
        $plos2_tinted.hide();
        $plos2_polarized.hide();
        break;
    }
    $plos2_next_btn.show();
    $plos2_prescription_select.hide();
    $plos2_prescription_upload.hide();
    $plos2_prescription_doctor.hide();
    $plos2_pd_select.hide();
    $plos2_pd_upload.hide();
    $plos2_pd_enter.hide();
    $plos2_submit_btn.hide();
    
    $("html").animate({ scrollTop: 0 }, scrollSpeed);  
  });

  /* plos2_prescription_type */
  $plos2_prescription_type.find(".progress_lens_options_step_2_optionButton").on("click",function(){
    $plos2_prescription_type.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    $plos2_prescription_type.find(".check_img").remove();
    $(".plos2_prescription_type_selected").removeClass("plos2_prescription_type_selected progress_lens_options_step_2_optionButton_selected");
    
    $(this).addClass("plos2_prescription_type_selected progress_lens_options_step_2_optionButton_selected");
    $(this).append($(check_mark_html));
    
    $(".plos2_lens_metarial_selected").removeClass("plos2_lens_metarial_selected progress_lens_options_step_2_optionButton_selected");
    
    var nextAction = $(this).data("optionValue");
    switch(nextAction){
      case "single":
        $plos2_lens_metarial_single.show();
        $plos2_lens_metarial_progress.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_single.offset().top-scrollGap }, scrollSpeed);
        break;

      case "progressive":
        $plos2_lens_metarial_progress.show();
        $plos2_lens_metarial_single.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_progress.offset().top-scrollGap }, scrollSpeed);
        break;
    }
    
  });
  
  /* plos2_lens_metarial */
  $(".progress_lens_options_step_2_lens_metarial .progress_lens_options_step_2_optionButton").on("click",function(){
    $(".progress_lens_options_step_2_lens_metarial").find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    $(".progress_lens_options_step_2_lens_metarial .progress_lens_options_step_2_optionButton").find(".check_img").remove();
    
    $(".plos2_lens_metarial_selected").removeClass("plos2_lens_metarial_selected progress_lens_options_step_2_optionButton_selected");
    
    $(this).addClass("plos2_lens_metarial_selected progress_lens_options_step_2_optionButton_selected");
    $(this).append($(check_mark_html));
    
    $form.find("#progress_lens_options_input_lens").val($(this).data("optionValue"));
    $form.find("#progress_lens_options_input_lens_variant_id").val($(this).data("variantId"));
    $form.find("#progress_lens_options_input_lens_variant_price").val($(this).data("price"));

    preview.lensName = $(this).data("optionName");
    preview.lensPrice = $(this).data("price");
    updatePreview();
    
    matchDomHeights(".progress_lens_options_step_2_optionButton_description p");
    //$("html").animate({ scrollTop: $plos2_blue_filter.offset().top-scrollGap }, scrollSpeed);
  });

  /* plos2_blue_filter */
  $plos2_blue_filter.find(".progress_lens_options_step_2_optionButton").on("click",function(){
    var classNames = "plos2_blue_filter_selected progress_lens_options_step_2_optionButton_selected";
    var enabled = $(this).hasClass(classNames);
    
    if(enabled) {
      $(this).removeClass(classNames);
      $(this).find(".check_img").remove();
    
      
      $form.find("#progress_lens_options_input_blue_blocking_filter").val("");
      $form.find("#progress_lens_options_input_blue_blocking_filter_variant_id").val("");
      $form.find("#progress_lens_options_input_blue_blocking_filter_variant_price").val("");
      
      preview.optionName = undefined;
      preview.optionPrice = undefined;
      updatePreview();
    }
    else {
      $(this).addClass(classNames);
      $(this).append($(check_mark_html));

      $form.find("#progress_lens_options_input_blue_blocking_filter").val($(this).data("optionValue"));
      $form.find("#progress_lens_options_input_blue_blocking_filter_variant_id").val($(this).data("variantId"));
      $form.find("#progress_lens_options_input_blue_blocking_filter_variant_price").val($(this).data("price"));
      
      preview.optionName = $(this).data("optionName");
      preview.optionPrice = $(this).data("price");
      updatePreview();
    }
    
  });

  /* plos2_sun_color */
  $plos2_sun_color.find(".progress_lens_options_step_2_optionButton").on("click",function(){
    $plos2_sun_color.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    $plos2_sun_color.find(".check_img").remove();
    $(".plos2_sun_color_selected").removeClass("plos2_sun_color_selected progress_lens_options_step_2_optionButton_selected");
    
    $(this).addClass("plos2_sun_color_selected progress_lens_options_step_2_optionButton_selected");
    $(this).append($(check_mark_html));
    
    var nextAction = $(this).data("optionValue");
    switch(nextAction){
      case "tinted":
        $plos2_tinted.show();
        $plos2_polarized.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_single.offset().top-scrollGap }, scrollSpeed);
        break;

      case "polarized":
        $plos2_polarized.show();
        $plos2_tinted.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_progress.offset().top-scrollGap }, scrollSpeed);
        break;
    }
      
    preview.colorName = "";
    preview.colorPrice = "";
    updatePreview();
    
    $plos2_tinted.find("input[name='tinted']").checked
    
  });

  /* plos2_tinted */
  $plos2_tinted.find("input[name='tinted']").on("click",function(){
    $plos2_tinted.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    $(".plos2_tinted_selected").removeClass("plos2_tinted_selected");
    $(this).addClass("plos2_tinted_selected");
    
    $form.find("#progress_lens_options_input_polarized").val("");
    $form.find("#progress_lens_options_input_polarized_variant_id").val("");
    $form.find("#progress_lens_options_input_polarized_variant_price").val("");
    
    if($(this).attr("id") == "other"){
      
      preview.colorName = "";
      preview.colorPrice = "";
      updatePreview();
    }
    else {
      $form.find("#progress_lens_options_input_tinted").val($(this).data("optionValue"));
      
      preview.colorName = $(this).data("optionName");
      preview.colorPrice = '0';
      updatePreview();
    }
  });
  $plos2_tinted_manual.on("change",function(){
      var enteredText = $(this).val();
    if(enteredText.trim() == ""){
    }
    else {
      $form.find("#progress_lens_options_input_tinted").val(enteredText);
      
      preview.colorName = 'Lens Color: '+(enteredText.length>9?enteredText.substring(0,5)+"...":enteredText);
      preview.colorPrice = "0";
      updatePreview();
    }
  });

  /* plos2_polarized */
  $plos2_polarized.find("input[name='polarized']").on("click",function(){
    $plos2_polarized.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    $(".plos2_polarized_selected").removeClass("plos2_polarized_selected");
    $(this).addClass("plos2_polarized_selected");
    
    $form.find("#progress_lens_options_input_tinted").val("");
    
    $form.find("#progress_lens_options_input_polarized").val($(this).data("optionValue"));
    $form.find("#progress_lens_options_input_polarized_variant_id").val($(this).data("variantId"));
    $form.find("#progress_lens_options_input_polarized_variant_price").val($(this).data("price"));

    preview.colorName = $(this).data("optionName");
    preview.colorPrice = $(this).data("price");

    console.log("Options check: " + $(this).data("variantId"))
    updatePreview();
  });
  
  /* plos2_next_btn */
  $plos2_next_btn.find("button").on("click",function(e){
    var isFormValid = true;
    
    $(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    
    var nextAction = $(".plos2_prescription_type_selected").data("optionValue");
    switch(nextAction){
      case "single":
        $plos2_lens_metarial_single.show();
        $plos2_lens_metarial_progress.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_single.offset().top-scrollGap }, scrollSpeed);
        break;

      case "progressive":
        $plos2_lens_metarial_progress.show();
        $plos2_lens_metarial_single.hide();
    	//$("html").animate({ scrollTop: $plos2_lens_metarial_progress.offset().top-scrollGap }, scrollSpeed);
        break;
    }
    
    if($(".plos2_prescription_type_selected").length == 0){
      $plos2_prescription_type.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
      isFormValid = false;
    }
    
    if($(".plos2_lens_metarial_selected").length == 0){
      var nextAction = $(".plos2_prescription_type_selected").data("optionValue");
      switch(nextAction){
        case "single":
          $plos2_lens_metarial_single.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
          break;

        case "progressive":
          $plos2_lens_metarial_progress.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
          break;
      }
      isFormValid = false;
    }
    
    if(PRODUCT_TYPE == 'sun'){
      
      if($(".plos2_sun_color_selected").length == 0){
        $plos2_sun_color.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
        isFormValid = false;
      }
      
      var selectedSunColorType = $(".plos2_sun_color_selected").data("optionValue");
      switch(selectedSunColorType){
        case "tinted":
          if($(".plos2_tinted_selected").length == 0){
          	$plos2_tinted.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
      		isFormValid = false;
          }
          break;

        case "polarized":
          if($(".plos2_polarized_selected").length == 0){
          	$plos2_polarized.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
      		isFormValid = false;
          }
          break;
      }

    }
    
    if(PRODUCT_TYPE == 'sun' && $(".plos2_tinted_selected").attr("id")=="other" && $plos2_tinted_manual.val().trim() == ""){
      $plos2_tinted_manual.addClass("progress_lens_options_error");
      isFormValid = false;
    }
    
    if(isFormValid){
      $plos2_exit_btn.hide();
      $plos2_back_btn.show();
      $plos2_progression_lens_option.removeClass("progression_view_checked");
      $plos2_progression_prescription.addClass("progression_view_checked");

      $plos2_prescription_type.hide();
      $plos2_lens_metarial_progress.hide();
      $plos2_lens_metarial_single.hide();
      $plos2_blue_filter.hide();
      $plos2_sun_color.hide();
      $plos2_tinted.hide();
      $plos2_polarized.hide();
      $plos2_next_btn.hide();
      $plos2_prescription_select.show();

      switch($(".plos2_perscription_selected").data("nextAction")){
        case "UploadPrescription":
          $plos2_prescription_upload.show();break;

        case "InputDoctorInformation":
          $plos2_prescription_doctor.show();
          break;
      }
      $plos2_pd_select.show();
      switch($(".plos2_pd_selected").data("nextAction")){
      case "InputPd":
        $plos2_pd_enter.show();
        break;

      case "UploadSelfTest":
        $plos2_pd_upload.show();
        break;
      }
      $plos2_submit_btn.show();

      $("html").animate({ scrollTop: 0 }, scrollSpeed);   
    }
    else{
      var $errorField = $(".progress_lens_options_error");
      var message = "Please complete the incomplete form field(marked red)";
      if($errorField.length > 1){
        message="Please complete the incomplete form fields(marked red)";
      }
      //console.log("$errorField: ", $errorField);
      $("html").animate(
        { scrollTop: $errorField.eq(0).offset().top-scrollGap },
        { duration: scrollSpeed, complete:  function() { alert(message) } }
      );
    } 
  })

  /* plos2_prescription */
  $plos2_prescription_select.find(".progress_lens_options_step_2_optionButton").on("click",function(){
    $(".plos2_perscription_selected").removeClass("plos2_perscription_selected progress_lens_options_step_2_optionButton_selected");
    $(this).addClass("plos2_perscription_selected progress_lens_options_step_2_optionButton_selected");

    $plos2_prescription_select.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    $plos2_prescription_upload.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    $plos2_prescription_doctor.find(".progress_lens_options_error").removeClass("progress_lens_options_error");

    $plos2_prescription_select.find(".check_img").remove();
    $(this).append($(check_mark_html));
    
    $plos2_prescription_upload.hide();
    $plos2_prescription_doctor.hide();
    $form.find(".progress_lens_options_input_prescription").attr("disabled","disabled");

    switch($(".plos2_perscription_selected").data("nextAction")){
      case "UploadPrescription":
        $plos2_prescription_upload.show();
        $form.find("#progress_lens_options_input_prescription_upload").removeAttr("disabled");
        $("html").animate({ scrollTop: $plos2_prescription_upload.offset().top-scrollGap }, scrollSpeed);
        break;

      case "InputDoctorInformation":
        $plos2_prescription_doctor.show();
        $form.find("#progress_lens_options_input_prescription_text").removeAttr("disabled");
        $("html").animate({ scrollTop: $plos2_prescription_doctor.offset().top-scrollGap }, scrollSpeed);
        break;

      case "Skip":
        $form.find("#progress_lens_options_input_prescription_skip").removeAttr("disabled");
        $form.find("#progress_lens_options_input_prescription_skip").val("Send it Later");
        break;
    }
  })

  $form.find("#progress_lens_options_input_prescription_upload").on("change", function(){
    var uploadFile = $form.find("#progress_lens_options_input_prescription_upload").get(0).files[0];
    $plos2_prescription_upload.find("#progress_lens_options_step_2_prescription_filename").html(uploadFile?uploadFile.name:'');
    
    if(uploadFile){
      $("#progress_lens_options_step_2_prescription_upload_button").addClass("file_uploaded");
    }
    else {
      $("#progress_lens_options_step_2_prescription_upload_button").removeClass("file_uploaded");
    }
  });

  $plos2_prescription_doctor.find("input").on("change", function(){
    var doctorName = "Doctor Name: " + $plos2_prescription_doctor.find("input.doctor_name").val();
    var doctorPhone = ", Doctor Phone: " + $plos2_prescription_doctor.find("input.doctor_number").val();
    var patientName = ", Patient Name: " + $plos2_prescription_doctor.find("input.patient_name").val();
    var patientDob = ", Patient DOB: " + $plos2_prescription_doctor.find("input.patient_dob_mm").val()+"/"+
    $plos2_prescription_doctor.find("input.patient_dob_dd").val()+"/"+
    $plos2_prescription_doctor.find("input.patient_dob_yyyy").val();
    $form.find("#progress_lens_options_input_prescription_text").val(doctorName+"\n\r"+doctorPhone+"\n\r"+patientName+"\n\r"+patientDob)
  });

  /* plos2_pd */
  $plos2_pd_select.find("a.pd_pop_up_button").on("click", function(e){
  	$('.pd_pop_up, .progress_lens_options_step_2_screen').removeClass('progress_lens_options_hidden');
    $("html").animate({ scrollTop: $(".pd_pop_up").offset().top-scrollGap }, scrollSpeed);
  });

  $plos2_pd_select.find("a.pd_pop_up_close_button, progress_lens_options_step_2_screen").on("click", function(e){
  	$('.pd_pop_up, .progress_lens_options_step_2_screen').addClass('progress_lens_options_hidden');
  });

  $plos2_pd_select.find(".progress_lens_options_step_2_optionButton").on("click",function(){
    $(".plos2_pd_selected").removeClass("plos2_pd_selected progress_lens_options_step_2_optionButton_selected");
    $(this).addClass("plos2_pd_selected progress_lens_options_step_2_optionButton_selected");
    $plos2_pd_select.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    $plos2_pd_upload.find(".progress_lens_options_error").removeClass("progress_lens_options_error");
    $plos2_pd_enter.find(".progress_lens_options_error").removeClass("progress_lens_options_error");

    $plos2_pd_select.find(".check_img").remove();
    $(this).append($(check_mark_html));
    
    $plos2_pd_upload.hide();
    $plos2_pd_enter.hide();
    $form.find(".progress_lens_options_input_pd").attr("disabled","disabled");

    switch($(".plos2_pd_selected").data("nextAction")){
      case "InputPd":
        $plos2_pd_enter.show();
        $form.find("#progress_lens_options_input_pd_text").removeAttr("disabled");
        $("html").animate({ scrollTop: $plos2_pd_enter.offset().top-scrollGap }, scrollSpeed);
        break;

      case "UploadSelfTest":
        $plos2_pd_upload.show();
        matchDomHeights(".self_test_image_boxes .p1");
        matchDomHeights(".self_test_image_boxes .p2");
        $form.find("#progress_lens_options_input_pd_upload").removeAttr("disabled");
        $("html").animate({ scrollTop: $plos2_pd_upload.offset().top-scrollGap }, scrollSpeed);
        break;

      case "Skip":
        $form.find("#progress_lens_options_input_pd_skip").removeAttr("disabled");
        $form.find("#progress_lens_options_input_pd_skip").val("Send it Later");
        break;
    }
  });

  $form.find("#progress_lens_options_input_pd_upload").on("change", function(){
    var uploadFile = $form.find("#progress_lens_options_input_pd_upload").get(0).files[0];
    $("#progress_lens_options_step_2_pd_filename").html(uploadFile?uploadFile.name:'');
    
    if(uploadFile){
      $("#progress_lens_options_step_2_pd_upload_button").addClass("file_uploaded");
    }
    else {
      $("#progress_lens_options_step_2_pd_upload_button").removeClass("file_uploaded");
    }
  });

  $plos2_pd_enter.find("input").on("change", function(){
    var pd;
    if($("#pd_checkbox:checked").length >0 ){
      pd = "R: " + $plos2_pd_enter.find("#pd_2_1").val() +
        ", L: " + $plos2_pd_enter.find("#pd_2_2").val();
    } else {
      pd = $plos2_pd_enter.find("#pd_1").val();
    }
    $form.find("#progress_lens_options_input_pd_text").val(pd);
  });

  $plos2_pd_enter.find("#pd_checkbox").on("click",function(){
  	$(".pd_1").val("");
    $(".pd_2_1").val("");
    $(".pd_2_2").val("");
    $form.find("#progress_lens_options_input_pd_text").val("");
  });

  /* plos2_submit_btn */
  $plos2_submit_btn.find("#progress_lens_options_step_2_submit_btn").on("click",function(e){
    var isFormValid = true;
    var isSubmitting = false;

    $(".progress_lens_options_error").removeClass("progress_lens_options_error");
    
    if($(".plos2_perscription_selected").length>0){
      switch($(".plos2_perscription_selected").data("nextAction")){
        case "UploadPrescription":
          if(!$("#progress_lens_options_input_prescription_upload").get(0).files[0]){
            $("#progress_lens_options_step_2_prescription_upload_button").addClass("progress_lens_options_error");
            isFormValid = false;
          }
          break;
        case "InputDoctorInformation":
          $plos2_prescription_doctor.find("input").each(function(index, element){
            if(!$(element).val()){
              $(element).addClass("progress_lens_options_error");
              isFormValid = false;
            }
          })
          break;
      }
    }
    else{
      $plos2_prescription_select.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
      isFormValid = false;
    }

   if($(".plos2_pd_selected").length>0){
      switch($(".plos2_pd_selected").data("nextAction")){
        case "InputPd":
          if($("#pd_checkbox:checked").val()){
            $plos2_pd_enter.find(".pd_2").each(function(index, element){
              if(!$(element).val()){
                $(element).addClass("progress_lens_options_error");
                isFormValid = false;
              }
            });
          }else{
            $plos2_pd_enter.find(".pd_1").each(function(index, element){
              if(!$(element).val()){
                $(element).addClass("progress_lens_options_error");
                isFormValid = false;
              }
            });
          }
          break;
        case "UploadSelfTest":
          if(!$("#progress_lens_options_input_pd_upload").get(0).files[0]){
            $("#progress_lens_options_step_2_pd_upload_button").addClass("progress_lens_options_error");
            isFormValid = false;
          }
          break;
      }
    }
    else{
      $plos2_pd_select.find(".progress_lens_options_step_2_top").addClass("progress_lens_options_error");
      isFormValid = false;
    }

    console.log(isFormValid, isSubmitting)
    
    if(isFormValid && !isSubmitting){
      isSubmitting = true;
	  formSubmit();
    }
    else{
      var $errorField = $(".progress_lens_options_error");
      var message = "Please complete the incomplete form field(marked red)";
      if($errorField.length > 1){
        message="Please complete the incomplete form fields(marked red)";
      }

      $("html").animate(
        { scrollTop: $errorField.eq(0).offset().top-scrollGap },
        { duration: scrollSpeed, complete:  function() { alert(message) } }
      );
    }
  });


  /****************************/
  /* Init                     */
  /****************************/
  init();
});
